import {useTranslation} from 'react-i18next'
import {Tag} from '@/components/ui/tag'
import type {components} from '@/lib/api-schema'

type LicenciaEstado = components['schemas']['LicenciaEstado']
type LicenciaCategoria = components['schemas']['LicenciaCategoria']

/** Same tones as `LicenciaStatusStamp` (`employee-form-dialog.tsx`) and `licenciaEstadoTone`
 * (`licencia-sst-section.tsx`); any future estado falls to amber. */
export function LicenciaBadge({
  estado,
  categoria,
  className,
  testId,
}: {
  estado: LicenciaEstado | null
  categoria: LicenciaCategoria | null
  className?: string
  testId?: string
}) {
  const {t} = useTranslation()
  if (!estado) return null
  const tone = estado === 'verificada' ? 'green' : estado === 'rechazada' ? 'red' : 'amber'
  const categoriaLabel = categoria ? t(`licencia.categorias.${categoria}`) : null
  const title = categoriaLabel
    ? t('licencia.badgeTooltip', {categoria: categoriaLabel, estado: t(`licencia.estado.${estado}`)})
    : t('licencia.badgeTooltipNoCategoria', {estado: t(`licencia.estado.${estado}`)})
  return (
    <Tag tone={tone} title={title} className={className} data-testid={testId}>
      {t('licencia.badgeLabel')}
    </Tag>
  )
}
